import { agrChannelDict } from "@/pages/order-center/constant";
import type { AgrChannelType } from "@/pages/order-center/type";

/**
 * 是否小拉渠道
 * agr_channel: 渠道类型
*/
export const isXiaolaChannelFn = (agr_channel?: AgrChannelType) => agr_channel === agrChannelDict.kv.ATTV_AGR_CHANNEL_XL;